import axiosInstance from '../axiosInstance';
import {
  GET_LOGS_FOR_ENTITY_AND_HOUR_SERVICE_URL,
  GET_LOG_NODES_URL,
  GET_LOG_CONTENT_URL,
  LOG_FILENAME_APPENDIX,
  DOWNLOAD_LOGS_URL,
  END_TIME_URL_APPENDIX,
  START_TIME_URL_APPENDIX,
  LOGS_TYPE_NAME_APPENDIX,
} from './config';

export const api = {
  async getLogsForEntityAndHour(entityId: string, date: string) {
    const getLogsForEntityAndHourServiceUrl =
      GET_LOGS_FOR_ENTITY_AND_HOUR_SERVICE_URL +
      entityId +
      START_TIME_URL_APPENDIX +
      date;

    return axiosInstance.get(getLogsForEntityAndHourServiceUrl);
  },
  async getLogNodes(
    entityId: string,
    logStartDate: string,
    logEndDate?: string,
    LogsTypeName?: string,
  ) {
    let getLogNodesUrl =
      GET_LOG_NODES_URL + entityId + START_TIME_URL_APPENDIX + logStartDate;

    if (logEndDate) {
      getLogNodesUrl += END_TIME_URL_APPENDIX + logEndDate;
    }
    if (LogsTypeName) {
      getLogNodesUrl += LOGS_TYPE_NAME_APPENDIX + LogsTypeName;
    }

    return axiosInstance.get<string[]>(getLogNodesUrl);
  },

  async downloadLogNodes(
    entityId: string,
    startTime: string,
    endTime: string,
    selectedNodesForDownload: string[],
  ) {
    let logNodes = '';
    selectedNodesForDownload.forEach((node) => {
      logNodes += `&fileNames=${node}`;
    });

    const getLogNodesUrl = `${
      DOWNLOAD_LOGS_URL + entityId
    }&startTime=${startTime}&endTime=${endTime}${logNodes}`;

    return axiosInstance.get<string>(getLogNodesUrl);
  },
  async getLogContent(
    entityId: string,
    logFileName: string,
    logDateTime: string,
  ) {
    const getLogContentUrl =
      GET_LOG_CONTENT_URL +
      entityId +
      START_TIME_URL_APPENDIX +
      logDateTime +
      LOG_FILENAME_APPENDIX +
      logFileName;

    return axiosInstance.get<string>(getLogContentUrl);
  },
};

export type LogsApiType = typeof api;
